// extracted by mini-css-extract-plugin
export default {"header":"main_header_header__epghW","headerWithProgressBar":"main_header_headerWithProgressBar__kYxUP"};